import * as React from 'react'
import './styles.scss'
import BrandList from './Brand/BrandList'
import { I18n } from 'react-redux-i18n'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { company as companyApi } from '../../api'
const _ = require('lodash')

/**
 * Sort data
 * @param {[string]} order
 * @param {object|[object]} data
 *
 * @returns {object}
 */
function sortData(order, data) {
  const isArray = Array.isArray(data)
  const newData = isArray
    ? _.clone(data)
      .reduce((preV, next) => {
        preV[next._id] = next
        return preV
      }, {})
    : data
  const size = Object.keys(newData).length

  if (order && size > 0) {
    const sortData = {}
    const dataInSort = []

    order.forEach(it => {
      if (newData[it]) {
        sortData[it] = newData[it]
        dataInSort.push(it)
      }
    })

    if (size !== dataInSort.length) {
      Object.keys(newData).forEach(it => {
        if (!dataInSort.includes(it)) sortData[it] = newData[it]
      })
    }

    return isArray ? Object.values(sortData) : sortData
  }

  return data
}

const WrapperBrands = (props) => {
  const { brands: brandsStore, delegations: delegationsStore, company: companyStore, setSchedulesType } = props

  const [ brands, setBrands ] = React.useState({})
  const [ delegations, setDelegations ] = React.useState({})
  const [ company, setCompany ] = React.useState({})

  React.useEffect(() => {
    setDelegations(delegationsStore)
  }, [delegationsStore])
  React.useEffect(() => {
    setCompany(companyStore)
  }, [companyStore])

  React.useEffect(() => {
    orderBrands(company, brandsStore)
  }, [company, brandsStore])

  const orderBrands = (company, _brands) => {
    setBrands(sortData(company.brandsOrder, _brands))
  }

  const updateBrand = async (brand) => {
    companyApi.brands.updateBrand(brand)
      .catch(err => setBrands(brands))
  }

  const onDragEnd = async (e) => {
    const { type, source, destination, draggableId } = e
    if (!destination) return true

    // UPDATE BRANDS SORT
    if (type === "BRANDS") {
      const sourceIdx = source.index
      const destIdx = destination.index
      if (sourceIdx === destIdx) return true

      const brandsOrder = _.clone(company.brandsOrder).filter(elem => elem !== draggableId)
      const _company = _.clone(company)
      // New destination
      brandsOrder.splice(destIdx, 0, draggableId)
      _company.brandsOrder = brandsOrder

      orderBrands(_company, brands)
      companyApi.companies.update({ ...company, brandsOrder: brandsOrder })
        .then(c => {
          setCompany(c.data.company)
        }).catch(() => setCompany(company))

      return true
    }

    if (type === "DELEGATIONS") {
      const sourceId = source.droppableId
      const sourceIdx = source.index
      const destId = destination.droppableId
      const destIdx = destination.index

      const sameDroppable = sourceId === destId
      if (sameDroppable && sourceIdx === destIdx) return true

      if (sameDroppable) {
        const brand = _.clone(brands[sourceId])
        const delegationsOrder = brand.delegationsOrder.filter(elem => elem !== draggableId)

        delegationsOrder.splice(destIdx, 0, draggableId)
        orderBrands(company, { ...brands, [brand._id]: { ...brand, delegationsOrder: delegationsOrder } })
        updateBrand({ ...brand, delegationsOrder: delegationsOrder })

        return true
      }

      // Different droppable
      const brandSource = _.clone(brands[sourceId])
      const delegationsOrderSource = brandSource.delegationsOrder.filter(elem => elem !== draggableId)
      const brandDestination = _.clone(brands[destId])
      const delegationsOrderDestination = brandDestination.delegationsOrder.filter(elem => elem !== draggableId)

      delegationsOrderDestination.splice(destIdx, 0, draggableId)
      const delegation = delegations[draggableId]
      setDelegations({ ...delegations, [delegation._id]: { ...delegation, brand: brandDestination._id } })

      orderBrands(company, {
        ...brands,
        [brandDestination._id]: { ...brandDestination, delegationsOrder: delegationsOrderDestination },
        [brandSource._id]: { ...brandSource, delegationsOrder: delegationsOrderSource }
      })

      companyApi.delegations.updateDelegation({ ...delegation, brand: brandDestination._id })
        .then(d => {
          updateBrand({ ...brandDestination, delegationsOrder: delegationsOrderDestination })
          updateBrand({ ...brandSource, delegationsOrder: delegationsOrderSource })
        }).catch(() => setBrands(brands))
    }
  }

  return (
    <div className='animated fadeIn'>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="brands-list" direction="horizontal" type='BRANDS'>
          {(provided_c, snapshot) => (
            <div
              ref={provided_c.innerRef}
              {...provided_c.droppableProps}
              className='body-container'
            >
              {
                Object.values(brands).map((it, idx) => {
                  const _delegationsData = Object.values(delegations).filter(el => el.brand === it._id)
                  const totalOperators = _delegationsData.reduce((a, b) => a + b.totalOperators, 0)
                  const totalUsers = _delegationsData.reduce((a, b) => a + b.totalUsers, 0)

                  const _delegations = sortData(it.delegationsOrder, _delegationsData)

                  return (
                    <Draggable
                      key={it._id}
                      draggableId={it._id}
                      index={idx}
                    >
                      {(provided_q, snapshot) => (
                        <div
                          id={`brand-${it._id}`}
                          ref={provided_q.innerRef}
                          {...provided_q.draggableProps}
                          className='brand-container'
                          style = {{
                            ...provided_q.draggableProps.style,
                            opacity: snapshot.isDragging ? 0.7 : 1,
                            alignSelf: snapshot.isDragging ? 'flex-end' : 'none',
                          }}
                          {...provided_q.dragHandleProps}
                        >
                          <BrandList
                            {...provided_q.dragHandleProps}
                            key={idx}
                            brand={{ ...it, totalOperators: totalOperators || 0, totalUsers: totalUsers || 0, delegations: _delegations }}
                            delegations={_delegations}
                            openBrandModal={props.openBrandModal}
                            openDelegationModal={props.openDelegationModal}
                            setSchedulesType={setSchedulesType}
                          />
                        </div>
                      )}
                    </Draggable>
                  )
                })
              }
              {
                !snapshot.isDraggingOver &&
                    <div className='add-brand' onClick={props.openBrandModal}>
                      <div className='add-brand-plus'>
                        <div id='v' />
                        <div id='h' />
                      </div>
                      <span>{I18n.t('dashboard_add-brand')}</span>
                    </div>
              }
              {provided_c.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

    </div>
  )
}

export default WrapperBrands